export { IntegrateModel } from './Integrate.model';
